import { InlineOption } from "@/Common/Components/Inputs/InlineOptionsControl";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { ConfirmedEstimatedDateOfDeliveryBy } from "@/Patient/Models/ObstetricalFile/BritishColumbia/Part2/ConfirmedEstimatedDateOfDeliveryBy";

class BritishColumbiaObstetricalFileSection12 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const section12 = this.props.form.Section12;

        return (
            <div className="border border-bottom">
                <div className="section">
                    <div className="flex-display flex-wrap flex-col-gap-xl flex-row-gap-sm padding-sm-top padding-sm-bottom">
                        {this.renderTextboxWithCopyToHospitalCheckbox(
                            "ObstetricalFile_PlannedPlaceOfBirthAt20WeeksLabel",
                            section12.PlannedPlaceOfBirthAt20Weeks,
                            text => this.props.mutateModelState(s => s.Section12.PlannedPlaceOfBirthAt20Weeks = text),
                            section12.CopyToHospitalPlannedPlaceOfBirthAt20Weeks,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section12.CopyToHospitalPlannedPlaceOfBirthAt20Weeks = value),
                            this.getTitleNumberAsLabelPrefix(12),
                            this.page2FieldLimits.Section12_PlannedPlaceOfBirthAt20Weeks.MaxChars
                        )}
                        {this.renderTextboxWithCopyToHospitalCheckbox(
                            "ObstetricalFile_PlannedPlaceOfBirthAt36WeeksLabel",
                            section12.PlannedPlaceOfBirthAt36Weeks,
                            text => this.props.mutateModelState(s => s.Section12.PlannedPlaceOfBirthAt36Weeks = text),
                            section12.CopyToHospitalPlannedPlaceOfBirthAt36Weeks,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section12.CopyToHospitalPlannedPlaceOfBirthAt36Weeks = value),
                            null,
                            this.page2FieldLimits.Section12_PlannedPlaceOfBirthAt36Weeks.MaxChars
                        )}
                        <div style={{ maxWidth: "50%", flexGrow: 1 }}>
                            {this.renderField({
                                label: "ReferralHospitalLabel",
                                field: this.controlRenderer.renderTextbox({
                                    value: section12.ReferralHospital,
                                    onChange: value => this.props.mutateModelState(s => s.Section12.ReferralHospital = value),
                                    maxLength: this.page2FieldLimits.Section12_ReferralHospital.MaxChars
                                })
                            })}
                        </div>
                    </div>
                    <div className="row row-form">
                        <div className="col-md-12 inline-flex-center flex-col-gap-sm nowrap no-margin-label">
                            {this.renderInlineDatePicker(
                                "ObstetricalFile_ConfirmedEstimatedDateOfDeliveryAbbrevLabel",
                                section12.ConfirmedEstimatedDateOfDelivery,
                                value => {
                                    this.props.mutateModelStateWithFormUpdate(
                                        s => {
                                            s.Section12.ConfirmedEstimatedDateOfDelivery = value;
                                            s.updateSubsequentVisitGestationalAge(this.props.contributionId);
                                        }
                                    );
                                }
                            )}
                            <span>{this.getString("byLabel")}</span>
                            {this.controlRenderer.renderInlineRadio({
                                value: section12.ConfirmedEstimatedDateOfDeliveryBy,
                                items: this.getConfirmedEstimatedDateOfDeliveryByOptions(),
                                onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section12.ConfirmedEstimatedDateOfDeliveryBy = value),
                                id: "Section12_ConfirmedEstimatedDateOfDeliveryBy",
                                allowDeselect: true
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderTextboxWithCopyToHospitalCheckbox(
        label: string,
        text: string,
        onTextChange: (value: string) => void,
        bool: boolean,
        onBoolChange: (value: boolean) => void,
        titleNumberAsLabelPrefix?: React.ReactNode,
        maxLength?: number
    ): JSX.Element {
        return this.renderField({
            label: label,
            field: (
                <div className="flex-display flex-col-gap-sm flex-align-items-center">
                    {this.controlRenderer.renderTextbox({
                        value: text,
                        onChange: value => onTextChange(value),
                        maxLength: maxLength
                    })}
                    {this.controlRenderer.renderCheckbox(
                        "CopyToHospitalLabel",
                        bool,
                        value => onBoolChange(value),
                        "",
                        "margin-none"
                    )}
                </div>
            ),
            labelPrefix: titleNumberAsLabelPrefix
        });
    }

    private getConfirmedEstimatedDateOfDeliveryByOptions(): InlineOption<ConfirmedEstimatedDateOfDeliveryBy>[] {
        return [
            new InlineOption<ConfirmedEstimatedDateOfDeliveryBy>(ConfirmedEstimatedDateOfDeliveryBy.Ultrasound, this.getString("UltrasoundAbbrevLabel")),
            new InlineOption<ConfirmedEstimatedDateOfDeliveryBy>(ConfirmedEstimatedDateOfDeliveryBy.InVitroFertilization, this.getString("InVitroFertilizationAbbreviationLabel"))
        ];
    }
}

export { BritishColumbiaObstetricalFileSection12 };
